import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import { useHistory } from "react-router-dom";
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import { useForm } from 'react-hook-form';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet";
import Logobar from '../Shared/Logobar';

const login = () => {

  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, errors, handleSubmit } = useForm();
  const [showCommonError, setShowCommonError] = useState(false);

  let history = useHistory();

  const onSubmit = data => {
    dispatch( actions.login(data) ).then( (res) => {
      (res && res.error)? errorHandling(res.error) : history.push(ROUTES.TO_DASHBOARD)
    });
  } ;


  const intialValues = {
    email: "",
    password: ""
  };


  const errorHandling = (e) => {
    setShowCommonError(true);
  }

  const fieldClassName = (error) => {
    return (error)? "form-control is-invalid" : "form-control"
  }


  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName])?
       <div className="invalid-feedback">
          {ct('form.login.errors.' + fieldName + '.required')}
        </div> : null
  }


  return (

  <Aux>
    <Helmet>
      <meta name="description" content="Brandabschottungen mit dem Rudolf Hensel Product Selector einfach und zulassungskonform nach aBG oder ETA planen und verwalten." />
      <meta property="og:title" content="Konfigurator für Brandabschottungen und Brandschutzschotts" />
      <meta property="og:description" content="Brandabschottungen mit dem Rudolf Hensel Product Selector einfach und zulassungskonform nach aBG oder ETA planen und verwalten." />
      <meta property="og:url" content="https://www.productselector.de" />
      <meta property="twitter:title" content="Konfigurator für Brandabschottungen und Brandschutzschotts" />
      <meta property="twitter:description" content="Brandabschottungen mit dem Rudolf Hensel Product Selector einfach und zulassungskonform nach aBG oder ETA planen und verwalten." />

      <title>Konfigurator für Brandabschottungen und Brandschutzschotts</title>

      <link rel="apple-touch-icon" sizes="152x152" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#ffffff" />

      <meta name="thumbnail" content="https://www.productselector.de/ps_thumbnail.jpg" />


    </Helmet>

    <div className="main-container login">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6 col-md-7">
            <div className="text-center">
              <strong className="h2">{ ct('login.headline') }</strong>
              <p className="lead" style={{paddingBottom: "30px"}}>{ ct('login.subheadline') }</p>
              {
                (showCommonError === true)? <div className="alert alert-danger" role="alert">
                { ct('login.error.email_or_passwort_false') }
                </div> : null
              }
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <input
                    placeholder={ t('login.form.email.placeholder') }
                    className={(errors.email)? "form-control is-invalid" : "form-control"}
                    name="email"
                    defaultValue={intialValues.email}
                    ref={register({ required: true})}
                    {...register('email', { required: true })}
                     />

                   { (errors.email)?
                       <div className="invalid-feedback">
                          {errors.email.message}
                        </div> : null
                    }
                    { errors.email && !errors.email.message && errorMessage(errors, 'email') }

                </div>
                <div className="form-group">
                <input
                  placeholder={ t('login.form.password.placeholder') }
                  type="password"
                  className={fieldClassName(errors.password)}
                  name="password"
                  defaultValue={intialValues.password}
                  ref={register({ required: true, minLength: 8})} />
                   { (errors.password)?
                       <div className="invalid-feedback">
                          {errors.password.message}
                        </div> : null
                    }
                    { errorMessage(errors, 'password') }
                  <div className="text-right">
                    <small>
                      <Link to={ROUTES.TO_PASSWORD_FORGOTTEN}>{ ct('login.link.password_forgotten') }</Link>
                    </small>
                  </div>
                </div>

                <button type="submit" className="btn btn-lg btn-block btn-primary" style={{marginBottom: "20px"}}>{ ct('login.button.sign_in') }</button>

                <Link to={ROUTES.TO_WIZARD}>
                  <button type="submit" className="btn btn-lg btn-block btn-primary my-3" style={{marginBottom: "20px"}}>{ ct('login.button.go_to_wizard') }</button>
                </Link>

                <Link to={ROUTES.TO_REGISTER}>
                  <button type="submit" className="btn btn-lg btn-block btn-primary my-3" style={{marginBottom: "20px"}}>{ ct('login.not_signed_up_question.text') }</button>
                </Link>


              </form>
            </div>
          </div>
        </div>

        <Logobar />

        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-9 col-md-9">
            <div className="text-center">
              <h1 className="h6" style={{paddingTop: "40px", paddingBottom: "40px"}}>{ ct('login.what_is_productselector.subheadline') }</h1>
              <span className="text-justify">{ ht('login.description_productselector.text') }</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </Aux>
  );
};

export default login;



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js